import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { GetTrendyBlog } from "../../api/blogService";

const TrendyBlog = () => {
    const [trendingBlogs, setTrendingBlogs] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchTrendingBlogs = async () => {
        try {
            setLoading(true);
            setError(null);

            const response = await GetTrendyBlog();
            //console.log("response trendy", response)

            //console.log("data",data)
            // Validate Response & Map Data
            if (response?.Message?.[0]?.RETURNCODE === "1" && Array.isArray(response.TrendingBlog)) {
                //console.log("data response", response.TrendingBlog);

                const processedBlogs = response.TrendingBlog.map((blog, index) => ({
                    id: index + 1,
                    title: blog.BLOGTITLE,
                    image: blog.IMAGEURL,
                    description: blog.BLOGDESCRIPTION,
                    author: blog.POSTBY,
                    date: new Date(blog.POSTDATE).toLocaleDateString("en-US", {
                        year: "numeric",
                        month: "long",
                        day: "numeric",
                    }),
                    slug: blog.Slug,
                    // If the backend adds these fields later, fallback safely
                    readTime: blog.ReadTime ?? "5 min read",
                    category: blog.Category ?? "",
                    views: blog.Views ?? 0,
                    likes: blog.Likes ?? 0,
                    blogUrl: blog.BlogUrl ?? `/blog/${blog.Slug}`,
                    tags: blog.Tags || [],
                }));

                setTrendingBlogs(processedBlogs);
            } else {
                throw new Error("Invalid API response");
            }
        } catch (err) {
            setError(err.message);
            //setTrendingBlogs([getTrendingBlogs()]);
        } finally {
            setLoading(false);
        }
    };

    //const getTrendingBlogs = () => ({
    //    id: 1,
    //    title: "50 Trendy Lab-Grown Diamond Jewellery Designs This Festive Season",
    //    image: "/assets/images/Home/labgrown.png",
    //    description:
    //        "Discover the latest lab-grown diamond jewellery collection perfect for festive celebrations.",
    //    author: "Meera Jewels",
    //    date: "January 15, 2024",
    //    readTime: "5 min read",
    //    views: 1250,
    //    likes: 89,
    //    blogUrl: "/blog/trendy-lab-grown-diamond-designs",
    //    tags: ["Lab-Grown", "Festive", "Jewellery"],
    //});


    useEffect(() => {
        fetchTrendingBlogs();
    }, []);

    if (loading) {
        return (
            <section className="py-5 text-center">
                <div className="spinner-border" style={{ width: "3rem", height: "3rem" }}></div>
                <p className="mt-3">Loading trending blogs...</p>
            </section>
        );
    }

    if (error && trendingBlogs.length === 0) {
        return (
            <section className="py-5 text-center text-danger">
                <h4> Unable to fetch trending blogs</h4>
                <p>{error}</p>
                <button className="btn btn-primary mt-3" onClick={fetchTrendingBlogs}>
                    Retry
                </button>
            </section>
        );
    }

    return (
        <section
            className="quality-section position-relative py-5 overflow-hidden"
            style={{
                minHeight: "50vh",
                backgroundImage: "url('/assets/images/Home/bg_labgrown.png')",
                backgroundPosition: "bottom center",
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
                zIndex: 1,
            }}
        >
            <div className="container position-relative" style={{ zIndex: 2 }}>
                <div className="row align-items-center">

                    {/* Left Content */}
                    <div className="col-12 col-md-6 text-center text-lg-center text-md-start mb-4 mb-md-0" data-aos="slide-right">
                        <h2 className="display-6 mb-3 fw-semibold">
                            {trendingBlogs[0]?.title || "Trending Jewellery"}
                        </h2>

                        <Link to={`/learn/blog/${trendingBlogs[0]?.slug || ""}`}>
                            <button className="primary-button-quality mt-2">LEARN MORE</button>
                        </Link>
                    </div>

                    {/* Right Image */}
                    <div className="col-12 col-md-6 text-center text-md-end" data-aos="slide-left">
                        {trendingBlogs[0] && (
                            <img
                                src={trendingBlogs[0].image}
                                alt={trendingBlogs[0].title}
                                className="img-fluid"
                                style={{
                                    width: "100%",
                                    maxWidth: "480px",
                                    height: "auto",
                                    maxHeight: "450px",
                                    objectFit: "cover",
                                }}
                                onError={(e) => (e.target.src = "/assets/images/Home/labgrown.png")}
                            />
                        )}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default TrendyBlog;
